import { createTypedHooks } from "easy-peasy";
import { RootState } from "./storeModel";

const typedHooks = createTypedHooks<RootState>();

export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
export const useStoreState = typedHooks.useStoreState;
